export const parseBadRequestResponse = (errors) => {
  if (!errors) {
    return '';
  }
  const msgList = errors.map((item) => {
    return `${item.param} ${item.msg}`;
  });
  return msgList.join('<br>');
};
